export enum InsuranceType {
  CPD = 'CarPhysicalDamage',
  HCI = 'HospitalCashInsurance',
  PAI = 'PersonalAccidentInsurance',
  TPL = 'ThirdPartyLiability',
  TI = 'TravelInsurance',
}

export const INSURANCE_ALIAS_MAP: ToMap<string> = {
  'Third Party Liability - Motorcycle': 'BH TNDS',
  'Third Party Liability - Car': 'BH TNDS',
  'Personal Accident': 'PA',
  'Travel Insurance': 'Travel',
  'Hospital Cash': 'HC',
};

export const INSURANCE_ROUTER_MAP: ToMap<InsuranceType> = {
  'third-party': InsuranceType.TPL,
  'travel-insurance': InsuranceType.TI,
  'personal-accident': InsuranceType.PAI,
  'hospital-cash': InsuranceType.HCI,
  'car-physical-damage': InsuranceType.CPD,
};
